import liveDrawRemarkCardComponent from "./liveDrawRemarkCard.container";

export default liveDrawRemarkCardComponent;